<template>
  <a-layout-header
    id="layout-header"
    style="background: #fff; padding: 0"
  >
    <a-row>
      <a-col :span="16">

      </a-col>
      <a-col :span="8">
        <div class="options-container">
          <div class="bell" @click="onNotice">
            <a-badge :count="num">
              <a-icon type="bell" class="bell-icon"></a-icon>
            </a-badge>
          </div>
          <a-dropdown :placement="dropdownMenuPlacement">
            <a @click="e => e.preventDefault()">
              <a-avatar icon="user"></a-avatar>
              <span class="user-name">{{ realName }}</span>
            </a>
            <a-menu slot="overlay">
              <a-menu-item @click="showUserSettings">
                <a-icon type="user" />个人设置
              </a-menu-item>
              <a-menu-divider />
              <a-menu-item>
                <a @click="logout">
                  <a-icon type="logout" />
                  退出登录</a
                >
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </a-col>
    </a-row>
  </a-layout-header>
</template>

<script>
import defaultAvatar from "../assets/default-avatar.png";

export default {
  data() {
    return {
      userAvatar: defaultAvatar,
      dropdownMenuPlacement: "bottomRight",
      realName: "",
      num: ""
    };
  },
  mounted() {
    this.realName = localStorage.getItem("realName");
    this.fetchNum();
  },
  methods: {
    logout(e) {
      e.preventDefault();
      localStorage.removeItem("userId");
      localStorage.removeItem("realName");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("userMenu");
      localStorage.removeItem("roles");
      this.$store.dispatch("logoutUser");
      this.$router.push({ name: "Login" });
    },

    showUserSettings() {
      this.$router.push({ name: "Profile" });
      for (let menu of this.$store.state.userMenu) {
        if (menu.name === "个人中心") {
          this.openSubmenu(menu.menuId);
          break;
        }
      }
    },
    onNotice() {
      this.$router.push({ name: "Notification" });
    },
    fetchNum() {
      // fetchUnReadNum().then(resp => {
      //   if (resp.data.code === "SUCCESS") {
      //     this.num = resp.data.data;
      //   }
      // });
    }
  }
};
</script>

<style scoped>
.user-name {
  color: black;
  padding-left: 6px;
  padding-right: 90px;
}
.options-container {
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.bell {
  box-sizing: border-box;
  padding: 0 10px;
  cursor: pointer;
}
.bell-icon {
  font-size: 20px;
}
</style>
